import React, { useState, useEffect } from 'react';
import { Grid, Menu, Card, Icon, Segment, Message } from 'semantic-ui-react';

import { Result } from '../search/Result';

export const ResultContainerpages = ({ query, model, aliases, start = 0, size = 10 }) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [aggs, setAggs] = useState({});
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [noResults, setNoResults] = useState(false);
  const totalPages = Math.ceil(total / size);

  const handlePageChange = (page) => {
    if (page !== currentPage) {
      setCurrentPage(page);
    }
  };

  const rebuildPagination = () => {
    const pageItems = [];

    const addPage = (page) => {
      pageItems.push(
        <Menu.Item
          key={page}
          active={page === currentPage}
          onClick={() => handlePageChange(page)}
        >
          {page}
        </Menu.Item>
      );
    };

    const addEllipsis = (key) => { /** Create elipsis function */
      pageItems.push(
        <Menu.Item key={key} disabled>
          ...
        </Menu.Item>
      );
    };

    /** Chevron: Previous Item only if the page is past 1 */
    if (currentPage > 1) {
      pageItems.push(
        <Menu.Item key="prev" onClick={() => handlePageChange(currentPage - 1)}>
          <Icon name="chevron left" />
        </Menu.Item>
      );
    }

    /** First page is always there*/
    addPage(1);

    /** Show ellipsis only if we exceed three pages*/
    if (currentPage > 3) {
      addEllipsis("left-ellipsis");
    }

    /** Show page before current page (if > 1 and not already shown) */
    if (currentPage - 1 > 1) {
      addPage(currentPage - 1);
    }

    /** Show current page */
    if (currentPage !== 1 && currentPage !== totalPages) {
      addPage(currentPage);
    }

    /** Show page after current page (if < totalPages and not already shown) */
    if (currentPage + 1 < totalPages) {
      addPage(currentPage + 1);
    }

    /** Show ellipsis before last page if less than 2 pages from the end */
    if (currentPage < totalPages - 2) {
      addEllipsis("right-ellipsis");
    }

    /** Always show last page (if more than 1 page) */
    if (totalPages > 1) {
      addPage(totalPages);
    }

    /** Chevron: Next page action */
    if (currentPage < totalPages) {
      pageItems.push(
        <Menu.Item key="next" onClick={() => handlePageChange(currentPage + 1)}>
          <Icon name="chevron right" />
        </Menu.Item>
      );
    }

    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2em' }}>
        <Menu pagination>{pageItems}</Menu>
      </div>
    );
  };


  async function getData() {
    setNoResults(false);
    setLoading(true);
    const q = encodeURIComponent(query);
    const offset = (currentPage - 1) * size;
    let result;

    console.debug(`Fetching page ${currentPage}, offset ${offset}`);


   
    if (model === 'composers') {
      result = await fetch(`/go/api/v1/search?q=${q}&model=${model}&start=${offset}&size=${size}&only_text_author=false`);
    } else {
      result = await fetch(`/go/api/v1/search?q=${q}&model=${model}&start=${offset}&size=${size}`);
    }
   
   
   
    const json = await result.json();
    console.debug(json);

    setAggs(json.aggregations);

    if (!json.hits || json.hits.hits.length === 0) {
      setNoResults(true);
      setResults([]);
      setLoading(false);
      return;
  }

  setTotal(json.hits.total);

  const cards = json.hits.hits.map((h, i) => (
    <Result data={h} alias={model} key={i} query={query} />
  ));
  setResults(cards);
  setLoading(false);
  }

  useEffect(() => { // Resets the pagination to 1 when switch between songs, composers or othr tabs
    setCurrentPage(1);
  }, [model, query]);

  useEffect(() => {
    getData();
  }, [query, model, aliases, currentPage]);

  return (
    <Segment attached='bottom' loading={loading}>
        {total > size && rebuildPagination()}
        {noResults ? (
        <Message info>No results found.</Message>
        ) : (
        <Card.Group className="responsive-card-group" itemsPerRow={3}>
            {results}
        </Card.Group>
        )}
    </Segment>
  );
};
